// A feature flag has two knobs:
// - REACT_APP_..._ENABLED=true at build time turns it on for everyone, no matter what.
// - Otherwise, visiting any URL with ?<param>=1 turns it on for just this browser
//   (persisted in localStorage, via syncFromUrl) until ?<param>=0 is visited or the
//   storage is cleared — so it only has to be typed once, not on every page.
const createFeatureFlag = (envEnabled, storageKey, paramName) => {
    const isEnabled = () => envEnabled || localStorage.getItem(storageKey) === 'true';

    const syncFromUrl = (search) => {
        const params = new URLSearchParams(search);

        if (!params.has(paramName)) {
            return;
        }

        const value = params.get(paramName);

        if (value === '1' || value === 'true') {
            localStorage.setItem(storageKey, 'true');
        } else if (value === '0' || value === 'false') {
            localStorage.removeItem(storageKey);
        }
    };

    return {isEnabled, syncFromUrl};
};

const shopFlag = createFeatureFlag(process.env.REACT_APP_SHOP_ENABLED === 'true', 'SHOP_ENABLED', 'shop');
export const isShopEnabled = shopFlag.isEnabled;
export const syncShopFeatureFlagFromUrl = shopFlag.syncFromUrl;

const payByBankFlag = createFeatureFlag(process.env.REACT_APP_PAY_BY_BANK_ENABLED === 'true', 'PAY_BY_BANK_ENABLED', 'paybybank');
export const isPayByBankEnabled = payByBankFlag.isEnabled;
export const syncPayByBankFeatureFlagFromUrl = payByBankFlag.syncFromUrl;

const mollieFlag = createFeatureFlag(process.env.REACT_APP_MOLLIE_ENABLED === 'true', 'MOLLIE_ENABLED', 'mollie');
export const isMollieEnabled = mollieFlag.isEnabled;
export const syncMollieFeatureFlagFromUrl = mollieFlag.syncFromUrl;
